import { getFamilyGroups } from "../../directory/getFamilyGroups";
export function getGroupName(member) {
    return getFamilyGroups(member.groups)[0];
}
